import config from '../../config.json';

export const conLog = (...args: any[]) => {
    // show source file and line number
    if (config.env === 'development') {
        console.log(...args);
    }
};
